const state = () => ({
    regiones: [],
    regionSeleccionada: null,
    selectedPlano: null,
    regionNueva: null,
    stateSelectedNode: null,

});
const getters = {};
const mutations = {
    setSelectedPlano(state, plano) {
        state.selectedPlano = plano;
    },
    setRegionNueva(state, region) {
        state.regionNueva = region;
    }
};

const actions = {
    async fetchRegiones({ state }, planoId) {
        try {
            const res = await state.myAxios.get(`api/planos/${planoId}/regiones`);
            state.regiones = res.data.map((r) => ({
                id: r.id_region,
                x: parseFloat(r.x),
                y: parseFloat(r.y),
                nombre: r.nombre_region
            }));
        } catch (error) {
            console.error("Error fetching regiones:", error);
        }
    },
    async setRegionSeleccionada({ state }, region) {
        state.regionSeleccionada = region;
    },
    async setSelectedPlano({ commit }, plano) {
        commit('setSelectedPlano', plano);
    },
    async setRegionNueva({ commit }, region) {
        commit('setRegionNueva', region);
    },
    async setSelectedNode({ state }, node) {
        state.stateSelectedNode = node;
    }


};
export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions,
};
